var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle7, _circle8, _circle9, _circle10, _path17;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartIlustrationRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 115,
    viewBox: "0 0 150 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1339,
    cy: 61.9909,
    r: 47.0089,
    fill: "#FFE7E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0714,
    cy: 30.2501,
    r: 2.94643,
    fill: "#FFE7E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.4735,
    cy: 9.49107,
    r: 5.49107,
    fill: "#FFE7E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.4908,
    cy: 99.4913,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.491,
    cy: 87.1695,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.312,
    cy: 93.0627,
    r: 2.54464,
    fill: "#FFE7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.819 17.2688C77.6637 17.2358 77.6637 17.0142 77.819 16.9812L80.1669 16.4819C80.2235 16.4698 80.2678 16.4257 80.2801 16.3692L80.7856 14.0378C80.8191 13.8833 81.0396 13.8833 81.0731 14.0378L81.5786 16.3692C81.5909 16.4257 81.6351 16.4698 81.6917 16.4819L84.0397 16.9812C84.195 17.0142 84.195 17.2358 84.0397 17.2688L81.6917 17.7681C81.6351 17.7802 81.5909 17.8243 81.5786 17.8808L81.0731 20.2122C81.0396 20.3667 80.8191 20.3667 80.7856 20.2122L80.2801 17.8808C80.2678 17.8243 80.2235 17.7802 80.1669 17.7681L77.819 17.2688Z",
    fill: "#F8AFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.167 65.238C24.2269 64.9548 24.6311 64.9548 24.6911 65.238L25.5865 69.4682C25.6083 69.5713 25.6886 69.652 25.7915 69.6744L29.978 70.5864C30.2591 70.6477 30.2591 71.0486 29.978 71.1099L25.7915 72.0219C25.6886 72.0443 25.6083 72.1251 25.5865 72.2281L24.6911 76.4583C24.6311 76.7415 24.2269 76.7415 24.167 76.4583L23.2716 72.2282C23.2498 72.1251 23.1695 72.0443 23.0666 72.0219L18.8801 71.1099C18.599 71.0486 18.599 70.6477 18.8801 70.5864L23.0666 69.6744C23.1695 69.652 23.2498 69.5713 23.2716 69.4682L24.167 65.238Z",
    fill: "#F8AFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.146 31.488C117.206 31.2048 117.61 31.2048 117.67 31.488L118.192 33.9558C118.214 34.0589 118.294 34.1396 118.397 34.162L120.846 34.6956C121.128 34.7569 121.128 35.1578 120.846 35.2191L118.397 35.7526C118.294 35.7751 118.214 35.8558 118.192 35.9589L117.67 38.4267C117.61 38.7098 117.206 38.7098 117.146 38.4267L116.623 35.9589C116.601 35.8558 116.521 35.7751 116.418 35.7526L113.969 35.2191C113.688 35.1578 113.688 34.7569 113.969 34.6956L116.418 34.162C116.521 34.1396 116.601 34.0589 116.623 33.9558L117.146 31.488Z",
    fill: "#F8AFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.945 71.0527L128.765 74.9279L132.585 75.7601L128.765 76.5922L127.945 80.4674L127.125 76.5922L123.305 75.7601L127.125 74.9279L127.945 71.0527Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.786 40.6963L38.4375 64.9374L51.9643 102.571L60.1339 106.187L70.3125 108.33L80.625 107.928L86.6518 106.857L92.0089 105.25L100.848 100.696L108.348 94.8034L108.927 94.0549C112.196 89.8297 115.094 85.3303 117.589 80.607L101.786 40.6963Z",
    fill: "#FFE7E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2589 54.2231L36.5625 50.4731L94.6875 28.5088L91.6071 36.1427L93.8839 43.2409L45.8036 61.5891L43.2589 54.2231Z",
    fill: "#FFD3D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6963 102.437V102.437C57.5575 105.434 63.903 107.37 70.4389 108.154L70.6022 108.173L75.2621 108.173C78.7527 108.173 82.2334 107.802 85.6453 107.065L86.8005 106.816C90.4485 106.028 93.9707 104.742 97.2678 102.994V102.994C99.8404 101.629 102.259 99.9927 104.482 98.1118L105.203 97.5013C107.133 95.8689 108.923 94.0789 110.555 92.1497V92.1497C112.841 89.4486 114.804 86.4904 116.405 83.335L117.857 80.4731",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9238 64.3784L51.9645 102.696",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.343 40.6733L117.746 80.921",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5131 50.5839L95.5113 28.0388",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6136 65.0689L101.5 40.4314L92.0816 36.0575C91.8111 35.9319 91.6953 35.6097 91.8239 35.3407L95.1037 28.4777",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.051 50.3988L42.8043 54.0195C43.0611 54.1571 43.1607 54.4747 43.0288 54.7343L37.9234 64.7802",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7803 49.9146L40.1317 60.7917",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.125 54.625L45.8036 62.125",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.875 35.875L94.5536 43.6429",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1504 28.603L98.995 39.2",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.0801,
    cy: 61.4551,
    r: 2.8125,
    fill: "#FFD3D2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.0626,
    cy: 46.9909,
    r: 2.00893,
    fill: "#FFE7E7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.7588,
    cy: 54.7588,
    r: 2.8125,
    fill: "#FFD3D2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.3839,
    cy: 42.4372,
    r: 2.00893,
    fill: "#FFE7E7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6704 90.94C95.482 91.021 95.274 91.0487 95.07 91.0193L85.4431 90.0228L79.9575 96.5988C79.0643 97.6756 77.465 97.8253 76.3876 96.9305C76.3742 96.9197 76.3609 96.9088 76.347 96.8965C75.9123 96.516 75.6106 96.0103 75.4819 95.4478L73.6192 86.8676L65.6187 83.3903C64.3042 82.8044 63.6922 81.2792 64.2364 79.9457C64.4456 79.4199 64.8264 78.9816 65.3176 78.7018L72.6425 74.3869L73.2114 65.7666C73.2795 64.3744 74.4628 63.2998 75.8565 63.3672C76.4607 63.396 77.0335 63.642 77.4713 64.0572L83.8666 69.9116L92.1743 67.9696C92.8448 67.8101 93.5528 67.9319 94.1332 68.3042C95.2258 69.0222 95.6607 70.4101 95.1742 71.6236L91.7957 79.5881L94.3218 83.6009C94.6923 84.2065 94.5128 84.9987 93.9137 85.381C93.3224 85.7511 92.5429 85.5719 92.1721 84.979L89.632 80.9717C89.179 80.2322 89.1059 79.3205 89.4386 78.5207L92.815 70.5104L84.5011 72.4369C83.656 72.627 82.7722 72.3711 82.159 71.7605L75.7776 65.9364L75.1949 74.688C75.1745 75.5546 74.7121 76.3489 73.9701 76.7957L66.6452 81.1107L74.5767 84.5726C75.3647 84.9118 75.9377 85.6104 76.1194 86.448L77.9821 95.0281L83.4724 88.4682C84.0089 87.8004 84.855 87.4609 85.7044 87.5726L95.3205 88.5734C95.9108 88.6436 96.3808 89.1033 96.4647 89.6928C96.5594 90.2779 96.2394 90.8499 95.694 91.0795L95.6704 90.94Z",
    fill: "#F8AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIlustrationRating);
export default __webpack_public_path__ + "static/media/cart_ilustration_rating.90056d3d330667dd27ea3f585fba8cce.svg";
export { ForwardRef as ReactComponent };